import { squadService } from "@/services/api/squad.service";
import { useQuery } from "@tanstack/react-query";

export function useSquadMembers(squadId: number | undefined, enabled: boolean = true) {
  const query = useQuery({
    queryKey: ["squads-members", squadId],
    queryFn: () => squadService.getMembersBySquadId(squadId!),
    staleTime: 1000 * 60 * 5,

    enabled: !!squadId && enabled,
  });

  return {
    squadMembersData: query.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    refetchSquadMembers: query.refetch,
  };
}
